export default __webpack_public_path__ + "static/media/element_31.e5bcc820.jpg";